import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProjetoDetalhesPage } from './projeto-detalhes.page';

const routes: Routes = [
  { path: '', component: ProjetoDetalhesPage, },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjetoDetalhesPageRoutingModule { }
